import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Funciona si tengo más de 50 años?',
  a: 'Sí. Los fibroblastos no tienen fecha de vencimiento. A cualquier edad, darle los nutrientes correctos activa la producción. Los resultados son graduales pero reales y sostenibles.'
}, {
  q: '¿Los ingredientes son caros o difíciles de encontrar?',
  a: 'No. Todo está disponible en cualquier supermercado. El costo diario del protocolo es menor al de un café con leche.'
}, {
  q: '¿Cuándo veo resultados?',
  a: 'Los primeros cambios en luminosidad aparecen entre los 15 y 21 días. La firmeza visible requiere 45 a 90 días de consistencia.'
}, {
  q: '¿Cómo accedo?',
  a: 'Inmediatamente después de tu compra recibirás el enlace de descarga en tu correo. Acceso instantáneo las 24 horas desde cualquier dispositivo.'
}, {
  q: '¿El precio promocional es real?',
  a: 'Es el precio de lanzamiento válido únicamente durante el tiempo indicado en el contador. Después sube a $29 USD sin excepciones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-blanco py-16 md:py-24 px-4" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="text-[28px] md:text-[40px] font-playfair font-bold text-marron text-center mb-12" data-id="element-29">
          🤔 PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300" data-id="element-31">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-32">
                <span className="font-montserrat font-bold text-marron text-lg pr-4" data-id="element-33">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-terracota flex-shrink-0" data-id="element-34" /> : <ChevronDown className="w-5 h-5 text-verde flex-shrink-0" data-id="element-35" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-36">
                <p className="text-carbon leading-relaxed" data-id="element-37">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}